<template>
  <div>
    <search-bar :items="searchItems" @search="search">
    </search-bar>

    <div class="card">
      <div flex>
        <div>
          <el-button type="primary" round size="small" icon="el-icon-plus" @click="$open('/doc-pk-edit/new', 1000)">New Packing List</el-button>
        </div>
        <el-pagination 
          @size-change="pageSizeChange" 
          @current-change="pageChange" 
          :current-page="currentPage" 
          :page-sizes="[20, 50, 100, 500]" 
          :page-size="pageSize" 
          layout="total, sizes, pager" 
          :total="total" 
          style="text-align:right;"
          flex-box="1">
        </el-pagination>
      </div>
      <table class="fixed-table" style="margin-top:10px;">
        <tr>
          <th style="width:60px;">View</th>
          <th style="width:102px;">PK date</th>
          <th style="width:102px;">PK No.</th>
          <th style="width:110px;">Doc No.</th>
          <th style="width:110px;">E-R No.</th>
          <th>Company</th>
          <th style="width:100px;">Sales</th>
        </tr>
        <template v-for="item in list">
          <tr :key="item.id + '1'" style="background-color:#eae9fe;" v-if="item.is_del == '0'">
            <td v-if="user.role_id>=3 && item.create_oper_id!=user.id">&nbsp;</td>
            <td v-else><a @click="$open(`/packing-list-view/${item.id}`, 840)">view</a></td>
            <td>{{ item.doc_date }}</td>
            <td>PK&nbsp;CY<span v-if="user.role_id>=3 && item.create_oper_id!=user.id">{{ item.id }}</span><a v-else @click="$open('/doc-pk-edit/' + item.id, 1000)">{{ item.id }}</a></td>
            <td><a @click="$open(`/invoice-order-view/${item.doc_id}`, 840)" v-if="item.doc_type === 'pi'">{{ item.doc_no }}</a><a @click="$open(`/po-order-view/${item.doc_id}`, 840)" v-else>{{ item.doc_no }}</a></td>
            <td>{{ item.e_r_no }}</td>
            <td><template v-if="user.role_id>=3 && item.create_oper_id!=user.id">&nbsp;</template><span style="color:blue;" v-else>{{ item.company_name }}</span></td>
            <td>{{ item.sales_name }}</td>
          </tr>
          <tr v-else style="color:red;background-color:#eae9fe;">
            <td v-if="user.role_id>=3 && item.create_oper_id!=user.id">&nbsp;</td>
            <td v-else><a @click="$open(`/packing-list-view/${item.id}`, 840)">view</a></td>
            <td>{{ item.doc_date }}</td>
            <td>PK&nbsp;CY{{ item.id }}</td>
            <td><a @click="$open(`/invoice-order-view/${item.doc_id}`, 840)" v-if="item.doc_type === 'pi'">{{ item.doc_no }}</a><a @click="$open(`/po-order-view/${item.doc_id}`, 840)" v-else>{{ item.doc_no }}</a></td>
            <td>{{ item.e_r_no }}</td>
            <td><template v-if="user.role_id>=3 && item.create_oper_id!=user.id">&nbsp;</template><span style="color:blue;" v-else>{{ item.company_name }}</span></td>
            <td>{{ item.sales_name }}</td>
          </tr>
        </template>
      </table>
      <no-data :loading="loading" :list="list"></no-data>
      <el-pagination @size-change="pageSizeChange" @current-change="pageChange" :current-page="currentPage" :page-sizes="[20, 50, 100, 500]" :page-size="pageSize" layout="total, sizes, pager" :total="total" style="text-align:right;"></el-pagination>
    </div>
  </div>
</template>

<script>
import ListFunc from '@/mixins/ListFunc'
import NoData from '@/components/NoData'
import qs from 'qs'
import moment from 'moment'
export default {
  mixins: [ListFunc],
  components: {
    NoData
  },
  data () {
    return {
      sqlcode: 'packing_list'
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    searchItems () {
      return [
        { key: 'company_name', label: 'Comp.name', type: 'input', width: 260 },
        { key: 'sales_id', label: 'Sales', type: 'select', state: 'sales', option_label: 'realname', option_value: 'id', defaultValue: this.user.role_id < 3 ? null : this.user.id, width: 160 },
        { key: 'id', label: 'PK No.', type: 'input', width: 160 },
        { key: 'doc_no', label: 'Doc No.', type: 'input', width: 160 },
        { key: 'part_no', label: 'Part Number', type: 'input', width: 257 },
        { key: 'date', label: 'Date', type: 'daterange', placeholder: 'PK Date', defaultValue: [moment().subtract(7, 'days'), moment().endOf('day')] },
        { key: 'e_r_no', label: 'E-R No.', type: 'input', width: 160 }
      ]
    }
  },
  methods: {
    fetchList () {
      if (this.pageSize > 0) {
        this.params.start = (this.currentPage - 1) * this.pageSize
        this.params.limit = this.pageSize
      }
      this.loading = true
      this.$http.get('/dbapi/' + this.sqlcode, {
        params: {
          ...this.params,
          ...this.fixedParams
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }).then(data => {
        this.list = data.list
        this.total = data.total
        this.loading = false
      }).catch(() => this.loading = false)
    }
  }
}
</script>